@if (sharedData(); as sharedData) { @if (sharedData.data.plainTextPassword) {
<div class="push-bottom-md">
	<lib-message [type]="'info'" [icon]="'tip'" [title]="'Sample client credentials'"
		>See the app from the perspective of the client by logging in as one.

		<ui-simple-table
			class="push-top"
			[titleFontType]="'opacity'"
			[enableDivider]="false"
			[columnsPerRow]="2"
			[items]="demoUserSimpleTable()"
		></ui-simple-table>
	</lib-message>
</div>
} }

<div [libFlexRow]="isMobileOrTabletView()" [libFlexRowAlign]="'start'">
	<div libFlexColumn [libFlexSize]="isMobileOrTabletView() ? 'full' : 'fill'">
		<lib-card
			[title]="'Client info'"
			[subtitle]="'Overview of primary client attributes'"
			[buttons]="clientOverviewButtons()"
		>
			<ui-simple-table [items]="clientTableItems()"></ui-simple-table>
		</lib-card>

		<lib-card
			class="push-top-md"
			[title]="'Assigned packages'"
			[subtitle]="'Packages represent services that you provide your clients'"
		>
			<lib-list
				[items]="assignedPackageListItems()"
				[noItemsText]="authUserIsClient() ? 'You have no assigned packages' : 'Client has no assigned packages'"
			></lib-list>

			<div class="push-top" libFlexRow [libFlexRowAlign]="'start'">
				<div libFlexColumn [libFlexSize]="isMobileView() ? 'fill' : undefined">
					<lib-button-list [buttons]="assignedPackageButtons()"></lib-button-list>
				</div>
			</div>
		</lib-card>
	</div>

	<div libFlexColumn [libFlexSize]="isMobileOrTabletView() ? 'full' : 'fill'">
		<lib-card [isForm]="true" [title]="'Private notes'" [subtitle]="'These notes are only visible to you.'">
			<ui-text-area-form-field
				[height]="'large'"
				[valueAsSignal]="form.privateNotes"
				[enableGenAi]="true"
				[genAiClientContext]="sharedData()?.data"
				[maxLength]="2000"
			></ui-text-area-form-field>

			<ui-form-save-button
				[removeDivider]="true"
				[buttonType]="'primaryLight'"
				[title]="'Save notes'"
				[saveHandler]="savePrivateNotesHandler()"
				[logHandler]="formLogHandler()"
			></ui-form-save-button>
		</lib-card>

		<lib-card
			class="push-top-md"
			[isForm]="true"
			[title]="'Client notes'"
			[subtitle]="'Client will see these notes on their dashboard'"
		>
			<ui-text-area-form-field
				[height]="'large'"
				[valueAsSignal]="form.publicNotes"
				[enableGenAi]="true"
				[genAiClientContext]="sharedData()?.data"
				[maxLength]="2000"
			></ui-text-area-form-field>

			<ui-form-save-button
				[removeDivider]="true"
				[buttonType]="'primaryLight'"
				[title]="'Save notes'"
				[saveHandler]="savePublicNotesHandler()"
				[logHandler]="formLogHandler()"
			></ui-form-save-button>
		</lib-card>
	</div>
</div>
